<template>
  <div v-if="!isLoanLaunchMessagesCollapsed" class="loanlaunch-messages">
    <div class="loanlaunch-messages__title">
      <span class="cc-card-title"><img src="@/assets/LoanLaunchLogo.png" style="width:2rem;height:2rem;"/>Chat</span>
      <span>
        <span v-if="isLoanLaunchMessagesHovered && totalUnreadLoanLaunchMessages > 0"
              @mouseleave="isLoanLaunchMessagesHovered = false"
              class="loanlaunch-messages__unread-count">
          <span @click="markAllUnreadLoanLaunchMessagesAsRead"
                class="loanlaunch-messages__unread-count--button">
            <u>Mark</u>
          </span>
          &nbsp;all as unread
        </span>

        <span v-else-if="totalUnreadLoanLaunchMessages"
              @mouseover="isLoanLaunchMessagesHovered = true"
              class="loanlaunch-messages__unread-count fade-in-element">
          <span>
            {{ formatNumberWithCommas(totalUnreadLoanLaunchMessages) }}
          </span>
          &nbsp;Unread
        </span>
      </span>
      <button class="collapse-handle collapse-handle--inside" @click="toggleLoanLaunchMessages"><i class="fa-solid fa-arrow-right-from-bracket"></i></button>
    </div>
    <div ref="scrollContainer"
         class="loanlaunch-messages__feed"
         @scroll="onScrollLoanLaunchMessages">
      <div v-for="message in loanLaunchMessages"
           :key="message.id"
           @click="onLoanlaunchMessageClicked(message)"
           :class="['loanlaunch-message', {'loanlaunch-message--unread' : !message.isread}]">
        <div class="loanlaunch-message__top">
          <span class="loanlaunch-message__name">{{message.username}}</span><span class="loanlaunch-message__date" :title="formatDateTimeShort(message.sent)">{{toFuzzyTime(message.sent)}}</span>
        </div>
        <div class="loanlaunch-message__bottom" :title="message.messagetext">
          <span class="loanlaunch-message__content">{{message.messagetext}}</span>
        </div>
      </div>
      <i v-if="!loanLaunchMessages?.length && isFetchingLatestLoanLaunchMessages" class="fa-solid fa-spinner-third fa-spin loanlaunch-messages__feed__loader" style="--fa-animation-duration: 1s;"></i>
      </div>
    <i v-if="loanLaunchMessages?.length > 0 && isFetchingLatestLoanLaunchMessages" class="fa-solid fa-spinner-third fa-spin loanlaunch-messages__feed__loader loanlaunch-messages__feed__loader--bottom" style="--fa-animation-duration: 1s;"></i>
  </div>
  <div v-else class="loanlaunch-messages__handle" @click="toggleLoanLaunchMessages">
    <div class="loanlaunch-messages-badge-wrapper">
      <img src="@/assets/LoanLaunchLogo.png" style="width:2rem;height:2rem;" />
      <div v-if="totalUnreadLoanLaunchMessages > 0" class="loanlaunch-messages-badge-indicator"></div>
    </div>
    <button class="collapse-handle"><i class="fa-solid fa-chevron-left"></i></button>
  </div>
</template>

<script>
  import auth from "@/authConfig.js"
  import apiService from '../../api/api.service.js';
  import { formatDateTimeShort, formatNumberWithCommas, toFuzzyTime } from "@/helpers/formatters.js";

  export default {
    data() {
      return {
        azureId: null,
        accessToken: null,

        isLoanLaunchMessagesCollapsed:
          localStorage.getItem('isLoanLaunchMessagesCollapsed') === 'true',

        totalUnreadLoanLaunchMessages: null,
        isLoanLaunchMessagesHovered: false,
        debounceScrollTimeout: null,

        loanLaunchMessages: [],
        isFetchingLatestLoanLaunchMessages: false,
        cachedLoanLaunchMessagesPipelineQuery: null,

        loanLaunchMessagesIntervalId: null
      };
    },

    methods: {
      formatDateTimeShort,
      formatNumberWithCommas,
      toFuzzyTime,

      // UI

      toggleLoanLaunchMessages() {
        this.isLoanLaunchMessagesCollapsed =
          !this.isLoanLaunchMessagesCollapsed;

        localStorage.setItem(
          'isLoanLaunchMessagesCollapsed',
          this.isLoanLaunchMessagesCollapsed
        );

        if (this.isLoanLaunchMessagesCollapsed) {
          this.stopPolling();

          return;
        }

        this.startPolling();
      },

      scrollElementUpIfAtBottom(fetchNewer = false) {
        const el = this.$refs.scrollContainer;

        if (!el) return;

        if (!fetchNewer) {

          el.scrollTop += 25;

          return;
        }

        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;

        const isAtBottom =
          scrollTop + clientHeight >= scrollHeight - 10;

        if (isAtBottom) {
          el.scrollTop = scrollTop - 30;
        }
      },

      onScrollLoanLaunchMessages() {
        if (this.debounceScrollTimeout) {
          clearTimeout(this.debounceScrollTimeout);
        }

        this.debounceScrollTimeout = setTimeout(() => {
          const el = this.$refs.scrollContainer;

          if (!el) return;

          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          const clientHeight = el.clientHeight;

          const isNearBottom =
            scrollTop + clientHeight >= scrollHeight - 10;

          if (isNearBottom) {
            this.fetchLoanLaunchMessages();
          }
        }, 300);
      },

      onLoanlaunchMessageClicked(message) {
        const baseUrl = 'https://swift.goldstarfinancial.com';

        window.open(
          `${baseUrl}/ConsumerPortal/?id=${message.loanid}`,
          '_blank'
        );

        setTimeout(() => {
          message.isread = true;
        }, 1000);
      },



      // API

      async fetchUnreadLoanLaunchMessages(fetchNewer = false) {
        let req = {
          query: this.cachedLoanLaunchMessagesPipelineQuery,
          AzureId: this.azureId,
          LastMessageId: null,
          LastSentDate: null,
          TopCount: 0
        };
        
        await this.getUnreadLoanLaunchMessagesCount(req);
      },

      async fetchLoanLaunchMessages(fetchNewer = false) {

        if (this.isFetchingLatestLoanLaunchMessages) return;

        this.isFetchingLatestLoanLaunchMessages = true;

        const hadExistingMessages = this.loanLaunchMessages?.length > 0;

        let referenceMessage = null;

        if (this.loanLaunchMessages?.length > 0) {
          referenceMessage = fetchNewer
            ? this.loanLaunchMessages[0]
            : this.loanLaunchMessages[
            this.loanLaunchMessages.length - 1
            ];
        }

        let req = {
          query: this.cachedLoanLaunchMessagesPipelineQuery,
          AzureId: this.azureId,
          LastMessageId: referenceMessage?.id,
          LastSentDate: referenceMessage?.sent,
          TopCount: 35,
          IsForward: fetchNewer
        };

        let newMessages = await this.getLoanLaunchMessages(req);

        if (newMessages?.length > 0) {

          if (fetchNewer) {
            this.loanLaunchMessages.unshift(...newMessages);
          } else {
            this.loanLaunchMessages.push(...newMessages);
          }

          if (hadExistingMessages) {
            await this.$nextTick();

            this.scrollElementUpIfAtBottom(fetchNewer);
          }
        }

        this.isFetchingLatestLoanLaunchMessages = false;
      },

      async getUnreadLoanLaunchMessagesCount(req) {
        
        let res = await apiService.GetUnreadLoanLaunchMessages(
          req,
          this.accessToken
        );

        this.totalUnreadLoanLaunchMessages =
          res?.data?.data?.totalUnread;
      },

      async getLoanLaunchMessages(req) {

        let res =
          await apiService.GetLoanLaunchMessagesWithReadStatus(
            req,
            this.accessToken
          );

        if (res?.data?.data?.query) {
          this.cachedLoanLaunchMessagesPipelineQuery = res?.data?.data?.query;
        }

        return res?.data?.data?.messages ?? [];
      },

      startPolling() {

        if (this.loanLaunchMessagesIntervalId) return;

        this.loanLaunchMessagesIntervalId = setInterval(async () => {

          try {

            if (document.hidden) return;

            await Promise.all([
              this.fetchUnreadLoanLaunchMessages(),
              this.fetchLoanLaunchMessages(true)
            ]);

          } catch (error) {}
         
        }, 45000);
      },

      stopPolling() {
        clearInterval(this.loanLaunchMessagesIntervalId);
        this.loanLaunchMessagesIntervalId = null;
      }
    },

    async mounted() {
      const token = await auth.acquireTokenResponse();
      this.accessToken = token?.accessToken;

      this.azureId = localStorage.getItem("azure_id");
      
      await Promise.all([
        this.fetchUnreadLoanLaunchMessages(),
        this.fetchLoanLaunchMessages()
      ]);

      this.startPolling();

    },

    async beforeUnmount() {

      clearTimeout(this.debounceScrollTimeout);
      this.stopPolling();
    },

    components: {

    }
  }
</script>

<style scoped>
  .loanlaunch-messages {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 12px;
    max-width: 40rem;
    border: 1px solid var(--border-ltr);
    border-radius: 12px;
  }

  .loanlaunch-messages__title {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    align-items: center;
    font-weight: 600;
    width: 100%;
    font-size: 1.5rem;
    color: rgb(128 128 128 / 85%);
  }

    .loanlaunch-messages__title > span {
      display: flex;
      align-items: center;
    }

  .loanlaunch-messages__feed {
    flex: 1;
    overflow-y: scroll;
    margin-top: 0.5rem;
    overscroll-behavior: contain;
    /* Hide scrollbar for Chrome, Safari, and Opera */
    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For Internet Explorer and Edge */
  }

    .loanlaunch-messages__feed::-webkit-scrollbar {
      display: none;
      /* For Chrome, Safari, and Opera */
    }

  .loanlaunch-messages__feed__loader {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem;
    color: var(--border-dk);
  }

  .loanlaunch-messages__feed__loader--bottom {
    position: sticky;
    bottom: 0;
  }

  .loanlaunch-messages__unread-count {
    font-size: 1.2rem;
    display: flex;
    align-content: center;
  }

    .loanlaunch-messages__unread-count > span {
      color: rgb(237, 118, 107);
    }

  .loanlaunch-messages__handle {
    flex: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    background: white;
    padding: 0.5rem;
    cursor: pointer;
    overflow: visible;
    border: 1px solid var(--border-ltr);
    border-radius: 12px;
  }

  .collapse-handle {
    flex: 1;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    background: transparent;
    color: rgb(128 128 128 / 85%);
  }

  .collapse-handle--inside {
    margin-left: 0.5rem;
    font-size: 1.5rem;
    flex-grow: 0;
  }

    .collapse-handle--inside:hover {
      background: var(--background-dk);
    }

  .loanlaunch-message {
    width: 100%;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    font-size: 1.4rem;
    cursor: pointer;
  }

  .loanlaunch-message--unread {
    background: var(--background-dk);
  }

  .loanlaunch-message__top {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  .loanlaunch-message__bottom {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  .loanlaunch-message__name {
    font-weight: 600;
  }

  .loanlaunch-message__date {
    font-size: 0.8em;
    color: var(--kendo-subtle-text);
  }

  .loanlaunch-message__content {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: .75em;
    line-height: 1.3;
    margin-top: 0.3em;
    color: var(--kendo-subtle-text);
  }

  .loanlaunch-messages-badge-wrapper {
    position: relative;
    display: inline-block;
  }

  .loanlaunch-messages-badge-indicator {
    position: absolute;
    top: -0.5rem;
    right: -0.5rem;
    width: 1rem;
    height: 1rem;
    background-color: rgb(237, 118, 107);
    border-radius: 50%;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fade-in-element {
    animation: fadeIn 0.5s forwards;
  }
</style>
